import { Click, View } from '../actions'
import { analytics } from './lib'
import { Coupon, type CouponProperties } from '../objects/Coupon'
import { CouponScreen, type CouponScreenProperties } from '../objects/CouponScreen'

export function CouponCopyClick(properties: CouponProperties) {
  return analytics(new Click(), new Coupon(properties))
}

export function CouponScreenView(couponScreenProperties: CouponScreenProperties) {
  return analytics(new View(), new CouponScreen(couponScreenProperties))
}
